import React from 'react';

class Modal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            recmail: {name:"recmail", errMsg: "", value:"", pattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/},
            sendmail:{name:"sendmail", errMsg: "", value:"", pattern:/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/},
            mailsubj:{name:"mailsubj", errMsg: "", value:"", pattern:/^[A-Za-z]/},
            maildesc:{name:"maildesc", errMsg: "", value:"", pattern: /^[A-Za-z]/}
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.sendData = this.sendData.bind(this);
        this.resetState = this.resetState.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    handleModalClose(event){
        document.body.classList.remove('ios-device');
    }

    handleChange(event){
        let fieldObj = this.state[event.target.name];
        fieldObj.value = event.target.value;
        if(fieldObj.value !== ""){
            fieldObj.errMsg = "";
        }
        this.setState( {[event.target.name]: fieldObj});
    }

    handleFormSubmit(e){
        e.preventDefault();
        let errFound = this.validateForm();
        if(!errFound.length){
            let formData = {
                recmail : this.state['recmail'].value,
                sendmail : this.state['sendmail'].value,
                mailsubj : this.state['mailsubj'].value,
                maildesc : this.state['maildesc'].value
            }
            this.props.lpForm.hidden_fields.map((field) => formData[field.name] = field.value );

            this.sendData(formData);

            this.setState({
                isValidForm: true
            });
            setTimeout(()=>{
                this.resetState();
            },4000)
        }
    }
    sendData(formData){

        let XHR = new XMLHttpRequest();
        let urlEncodedData = "";
        let urlEncodedDataPairs = [];
        let name;

        for(name in formData) {
            urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(formData[name]));
        }

        urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');

        // XHR.addEventListener('load', function(event) {
        //     that.resetState();
        // });
        XHR.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                //   console.log(this.responseText);
            }else(console.log('err'))
        };
        // XHR.addEventListener('error', function(event) {
        //     alert('Oops! Something goes wrong.');
        // });


        XHR.open('POST', formData['pu']);

        XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        XHR.send(urlEncodedData);
    }

    resetState(){
        let recmail = this.state['recmail'];
        recmail.value = "";
        this.setState(recmail);

        let sendmail = this.state['sendmail'];
        sendmail.value = "";
        this.setState(sendmail);

        let mailsubj = this.state['mailsubj'];
        mailsubj.value = "";
        this.setState(mailsubj);

        let maildesc = this.state['maildesc'];
        maildesc.value = "";
        this.setState(maildesc);

        this.setState({
            isValidForm: false
        });
    }

    validateForm(){
        let errs = [];
        if(this.state["recmail"].value === ""){
            let fieldObj = this.state["recmail"];
            fieldObj.errMsg = "To Email can't be empty";
            errs.push("recmail");
            this.setState( {recmail:fieldObj});
        }else{
            if(this.state["recmail"].pattern.test(this.state["recmail"].value)){
                let fieldObj = this.state["recmail"];
                fieldObj.errMsg = "";
                this.setState( {recmail:fieldObj});
            }else{
                let fieldObj = this.state["recmail"];
                errs.push("recmail");
                fieldObj.errMsg = "Please enter a valid email address, Ex: name@xyz.domain";
                this.setState( {recmail:fieldObj});
            }
        }

        if(this.state["sendmail"].value === ""){
            let fieldObj = this.state["sendmail"];
            errs.push("sendmail");
            fieldObj.errMsg = "From Email can't be empty";
            this.setState( {sendmail:fieldObj});
        }
        else{
            if(this.state["sendmail"].pattern.test(this.state["sendmail"].value)){

                if(this.state["recmail"].value === this.state["sendmail"].value){
                    let fieldObj = this.state["sendmail"];
                    fieldObj.errMsg = "Same email address is not allowed";
                    errs.push("sendmail");
                    this.setState( {sendmail:fieldObj});
                }else{
                    let fieldObj = this.state["sendmail"];
                    fieldObj.errMsg = "";
                    this.setState( {sendmail:fieldObj});
                }
            }else{
                let fieldObj = this.state["sendmail"];
                errs.push("sendmail");
                fieldObj.errMsg = "Please insert a valid email address, Ex: name@xyz.domain";
                this.setState( {sendmail:fieldObj});
            }
        }
        // mailsubj field
        if(this.state["mailsubj"].value === ""){
            let fieldObj = this.state["mailsubj"];
            errs.push("mailsubj");
            fieldObj.errMsg = "Subject line can't be empty";
            this.setState( {mailsubj:fieldObj});
        }else{
            let fieldObj = this.state["mailsubj"];
            fieldObj.errMsg = "";
            this.setState({mailsubj:fieldObj});
        }

        if(this.state["maildesc"].value === ""){
            let fieldObj = this.state["maildesc"];
            errs.push("maildesc");
            fieldObj.errMsg = "Comments can't be empty";
            this.setState({maildesc:fieldObj});
        }else{
            let fieldObj = this.state["maildesc"];
            fieldObj.errMsg = "";
            this.setState( {maildesc:fieldObj});
        }
        return errs;
    }

    render(){

        let modalStyles = {
            color : '#000000'
        }

        let hiddenFields;
        if(this.props.lpForm){
            if(this.props.lpForm.hidden_fields.length){
                hiddenFields = this.props.lpForm.hidden_fields.map((field, index) => {
                    return <input key={"input" + index } type="hidden" name={field.name} value={field.value} />
                });
            }
        }

        return (
            <div style={modalStyles}  className="modal fade in" id="carModal" role="dialog" aria-labelledby="carModalLabel" aria-hidden="false" >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="carModalLabel">
                                <i className="fa-regular fa-envelope"></i> Email
                            </h4>
                            <button type="button" onClick={this.handleModalClose} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-success text-center" style={(this.state.isValidForm)?{display:"block"}:{display:"none"}} role="alert">
                                <strong>Form submitted successfully!</strong>
                            </div>
                            <form onSubmit={this.handleFormSubmit} noValidate="novalidate" className="px-3">
                                {hiddenFields}
                                <div className="form-group row email-frm has-feedback">
                                    <label className="col-sm-3 text-right control-label">To:</label>
                                    <div className="col-sm-9">
                                        <input type="text" placeholder="Email Address" name="recmail" onChange={this.handleChange.bind(this)} id="recmail" value={this.state["recmail"].value} className="form-control email-mdf" data-bv-field="recmail"/>
                                        <i className="form-control-feedback" data-bv-field="recmail" style={{display: 'none'}}></i>
                                        <small data-bv-validator="notEmpty" className="help-block">{this.state["recmail"].errMsg}</small>
                                    </div>
                                </div>
                                <div className="form-group row email-frm has-feedback">
                                    <label className="col-sm-3 text-right control-label">From:</label>
                                    <div className="col-sm-9">
                                        <input type="text" value={this.state["sendmail"].value}  placeholder="Email Address" name="sendmail" id="sendmail" onChange={this.handleChange.bind(this)} className="form-control email-mdf" data-bv-field="sendmail"/><i className="form-control-feedback" data-bv-field="sendmail" style={{display: 'none'}}></i>
                                        <small data-bv-validator="notEmpty" className="help-block">{this.state["sendmail"].errMsg}</small>
                                    </div>
                                </div>
                                <div className="form-group row email-frm has-feedback">
                                    <label className="col-sm-3 text-right control-label">Subject:</label>
                                    <div className="col-sm-9">
                                        <input type="text" value={this.state["mailsubj"].value} placeholder="Subject Line" name="mailsubj" id="mailsubj" onChange={this.handleChange.bind(this)} className="form-control email-mdf" data-bv-field="mailsubj"/><i className="form-control-feedback" data-bv-field="mailsubj" style={{display: 'none'}}></i>
                                        <small data-bv-validator="notEmpty" className="help-block">{this.state["mailsubj"].errMsg}</small></div>
                                </div>
                                <div className="form-group row email-frm area-form has-feedback">
                                    <label className="col-sm-3 text-right control-label">Comments:</label>
                                    <div className="col-sm-9">
                                        <textarea name="maildesc"  value={this.state["maildesc"].value} placeholder="Comments" id="maildesc" onChange={this.handleChange.bind(this)} cols="3" className="form-control" data-bv-field="maildesc"></textarea><i className="form-control-feedback" data-bv-field="maildesc" style={{display: 'none',top: '0px'}}></i>
                                        <small data-bv-validator="notEmpty" className="help-block">{this.state["maildesc"].errMsg}</small>
                                    </div>
                                </div>
                                <div className="form-group row email-frm modal-form-url">
                                    <label className="col-md-2 control-label text-right">URL:</label>
                                    <div className="col-md-10">{this.props.shareurl}
                                    </div>
                                </div>
                                <div className="form-group has-feedback">
                                    <div className="modal-footer">
                                        <button type="submit" id="emailsubmit" name="emailsubmit" className="btn btn-lg btn-primary " style={{border: 'none',padding: '7px 16px', fontSize: '15px'}} data-bv-field="emailsubmit">Send Email
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js